import { IRegisterKiwiSaverUser } from './../../models/registration/register';
import { Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { Observable, of, noop } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IRegisterUser } from '../../models/registration/register';
import { IRegistration } from 'src/app/models/registration/registration';
import { IVerification } from 'src/app/models/registration/verification';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';

@Injectable({
  providedIn: 'root'
})
export class RegisterService extends BaseHttpService {

  constructor(private http: HttpClient, private appConfig: AppConfig) {
    super();
  }

  get envSettings(): IEnvironmentConfig {
    return this.appConfig.getEnvironmentConfig();
  }

  register(user: IRegisterUser): Observable<any> {
    return this.http.post(`${this.envSettings.webApiUrl}register`, JSON.stringify(user), {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  getRegistrationStatus(investorEntityId: number): Observable<any> {
    return this.http.get(`${this.envSettings.webApiUrl}registration/${investorEntityId}/status`, {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  getRegistrationStep(investorEntityId: number): Observable<any> {
    return this.http.get(`${this.envSettings.webApiUrl}registration/${investorEntityId}`, {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  save(registration: IRegistration): Observable<any> {
    return this.http.post(`${this.envSettings.webApiUrl}registration/steps`, JSON.stringify(registration), {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  verifyMember(investorEntityId: number, userEntityId: number, data: IVerification): Observable<any> {
    return this.http.post(`${this.envSettings.webApiUrl}investorentity/${investorEntityId}/verify/${userEntityId}`, JSON.stringify(data), {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  registerKiwiSaver(user: Partial<IRegisterKiwiSaverUser>): Observable<Partial<IRegisterKiwiSaverUser>> {
    const jsonBody = JSON.stringify(user);
    const url = `${this.envSettings.webApiUrl}kiwisaver`;
    return this.http.post(url, jsonBody, {
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

}
